import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { DeleteUrlInput, DeleteUrlMutation } from '@/gql/graphql';

const DELETE_URL_MUTATION = graphql(`
  mutation DeleteUrl($input: DeleteUrlInput!) {
    deleteUrl(input: $input)
  }
`);

const useDeleteUrl = (
  options?: UseMutationOptions<DeleteUrlMutation, unknown, DeleteUrlInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(DELETE_URL_MUTATION, { input });
    },
    ...options,
  });
};

export default useDeleteUrl;
